<template>
    <div :class="['app-loader-fill']">
        <div class="element-progress">
            <div class="element-progress__bar">
                <div class="element-progress__bar-filled">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: {
        color: {
            type: String,
            default: 'slate-400'
        },
        width: {
            type: Number,
            default: null
        }
    }
}
</script>
